export const EMPTY_PHONE_MASK = '(___) ___-____';
export const PHONE_MASK = '(999) 999-9999';
